import React from "react";
import CheckboxUI, { CheckboxProps as Props } from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export interface CheckboxProps extends Props {
  label?: string;
}

export const Checkbox = ({
  label,
  ...rest
}: CheckboxProps): React.ReactElement => (
  <FormControlLabel
    control={<CheckboxUI {...rest} />}
    label={label}></FormControlLabel>
);
